import React from 'react'
import OrgExpenseReportsHistoricalReports from 'src/app/OrgExpenseReportsHistoricalReports/OrgExpenseReportsHistoricalReports'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { orgExpenseReportsHistoricalReportsRouteProps } from 'src/navigation/routeProps'

const OrgExpenseReportsHistoricalReportsAppRoute: AppRoute = {
  id: AppLocation.OrgExpenseReportsHistoricalReports,
  routeProps: orgExpenseReportsHistoricalReportsRouteProps,
  component: <OrgExpenseReportsHistoricalReports />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default OrgExpenseReportsHistoricalReportsAppRoute
